<template>
  <div class="relative" :key="restaurant.id">
    <div class="aspect-square sm:aspect-video bg-sand text-coral rounded overflow-hidden">
      <AtomMap :lat="restaurant.location?.lat" :lon="restaurant.location?.lon" :zoom="14" />
    </div>
    <div class="absolute z-10 bottom-4 right-4 bg-white rounded">
      <a class="button-coral text-xs" :href="locationUrl" target="_blank">{{ $t('restaurant.map.button') }}</a>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})

// Google Maps URL
const coordinates = `${props.restaurant?.location?.lat},${props.restaurant?.location?.lon}`
const locationUrl = computed(() => `https://www.google.com/maps/place/${coordinates}`)
</script>
